import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const authActions = authSlice.actions;
export const selectAuth = (state) => state.auth;
export default authSlice.reducer;
